const doc = [[({"articlePath":"/das-ganz-besondere-grand-hotel-115787460002", "title":"Das ganz besondere Grand Hotel", "lead":"Hotel des Jahres der «SonntagsZeitung»"})]];
module.exports = doc.length <= 1 ? doc[0] : doc;